"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Card = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactI18next = require("react-i18next");
var _useContextSelector = require("use-context-selector");
var _TotalAmount = require("./TotalAmount");
var _AmountItem = require("./AmountItem");
var _ui = require("../../../../ui");
var _providers = require("../providers");
var _page = require("../page");
var _hooks = require("../../../../../hooks");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var StyledTotalAmount = (0, _styledComponents.default)(_TotalAmount.TotalAmount)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin: 20px 0;\n"])));
var Card = function Card(_ref) {
  var children = _ref.children,
    serviceFee = _ref.serviceFee;
  var _useTranslation = (0, _reactI18next.useTranslation)(['libTransfers', 'libCommon']),
    t = _useTranslation.t;
  var _useContext = (0, _react.useContext)(_providers.BalanceContext),
    balanceName = _useContext.balanceName;
  var amount = (0, _useContextSelector.useContextSelector)(_page.PageContext, function (state) {
    return state.amount;
  });
  var convertedTickerAmount = (0, _useContextSelector.useContextSelector)(_page.PageContext, function (state) {
    return state.convertedTickerAmount;
  });
  var ticker = (0, _useContextSelector.useContextSelector)(_page.PageContext, function (state) {
    return state.ticker;
  });
  var convertedTicker = (0, _useContextSelector.useContextSelector)(_page.PageContext, function (state) {
    return state.convertedTicker;
  });
  var _useCalculatedSendInf = (0, _hooks.useCalculatedSendInfo)(),
    total = _useCalculatedSendInf.total,
    convertedTickerTotal = _useCalculatedSendInf.convertedTickerTotal,
    balanceAfterTransaction = _useCalculatedSendInf.balanceAfterTransaction,
    convertedBalanceAfterTransaction = _useCalculatedSendInf.convertedBalanceAfterTransaction,
    fee = _useCalculatedSendInf.fee,
    convertedTickerFee = _useCalculatedSendInf.convertedTickerFee;
  return /*#__PURE__*/_react.default.createElement(_ui.Card, null, /*#__PURE__*/_react.default.createElement(_ui.CardHeader, null, /*#__PURE__*/_react.default.createElement(_ui.CardTitle, null, t('transactionDetails'))), /*#__PURE__*/_react.default.createElement(_ui.CardBody, {
    className: "pt-0"
  }, /*#__PURE__*/_react.default.createElement(_AmountItem.AmountItem, {
    title: t('amount'),
    ticker: ticker,
    convertedTicker: convertedTicker,
    amount: amount,
    convertedTickerAmount: convertedTickerAmount
  }), fee && /*#__PURE__*/_react.default.createElement(_AmountItem.AmountItem, {
    title: t('serviceFee'),
    tooltip: serviceFee,
    ticker: ticker,
    convertedTicker: convertedTicker,
    amount: fee,
    convertedTickerAmount: convertedTickerFee,
    className: "mb-0"
  }), /*#__PURE__*/_react.default.createElement(StyledTotalAmount, {
    ticker: ticker,
    amount: total,
    convertedTicker: convertedTicker,
    convertedAmount: convertedTickerTotal
  }), /*#__PURE__*/_react.default.createElement(_AmountItem.AmountItem, {
    title: "".concat(balanceName !== null && balanceName !== void 0 ? balanceName : t('personal'), " ").concat(t('libCommon:balance').toLowerCase(), " ").concat(t('after'), ":"),
    ticker: ticker,
    convertedTicker: convertedTicker,
    amount: balanceAfterTransaction,
    convertedTickerAmount: convertedBalanceAfterTransaction
  }), children));
};
exports.Card = Card;